import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BannerComponent } from '../layout/banner/banner.component';
import { FooterComponent } from '../layout/footer/footer.component';
import { HeaderComponent } from '../layout/header/header.component';

@Component({
  selector: 'app-upload-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    BannerComponent,
    CommonModule,
    FooterComponent,
  ],
  templateUrl: './upload-layout.component.html',
  styleUrl: './upload-layout.component.scss',
})
export class UploadLayoutComponent {}
